export default {
  /*
   * index() lista los puntos de venta
   */
  index(params) {
    return Vue.http.get('billing/point_of_sales', {params}).then(response => response.data)
  }
}
